import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/image/logo/trust_fund_title.svg'


const _hoisted_1 = { class: "header-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "title",
  class: "header-logo"
}, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "login-btn"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "로그인", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "회원가입", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "login-btn respect" }, " 님", -1)
const _hoisted_9 = { class: "userinfo-menu-header" }
const _hoisted_10 = {
  class: "userinfo-menu-item",
  onclick: "location.href='https://trustfund.co.kr/increaseLimit';   "
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 투자한도")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("늘리기 ")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_nav_bar = _resolveComponent("nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-area",
      onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleNav(true))),
      ref: "headerElement"
    }, [
      (_openBlock(), _createElementBlock("div", {
        class: "menu",
        key: _ctx.menuElKey
      }, [
        _createVNode(_component_router_link, { to: { name: 'home' } }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navBarMenu, (menu, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(menu.route?'menu-item pointer-hover':'menu-item pointer-normal'),
            onClick: ($event: any) => (menu.route?_ctx.routeNavbar(menu.route):()=>{}),
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNav(true)))
          }, _toDisplayString(menu.title), 43, _hoisted_3))
        }), 128))
      ])),
      (_ctx.useIsLogin === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: { name: 'login' } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_router_link, { to: { name: 'register' } }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "login-btn logged-in pointer-hover",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.isOpenUserHeaderInfoFunc && _ctx.isOpenUserHeaderInfoFunc(...args))),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpenHeaderUserInfo = true))
          }, [
            _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
            _hoisted_8,
            _createElementVNode("div", {
              class: _normalizeClass(
            _ctx.isOpen
              ? 'arrow-btn pointer-hover selected'
              : 'arrow-btn pointer-hover'
          )
            }, null, 2),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "userinfo-menu-item",
                onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.toggleNav(false);
                _ctx.router.push('/mylounge/ivmt_status');
              }
            )
              }, " 마이라운지 "),
              _createElementVNode("div", {
                class: "userinfo-menu-item",
                onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.toggleNav(false);
                _ctx.router.push('/userinfo');
              }
            )
              }, " 회원정보 "),
              _withDirectives(_createElementVNode("div", _hoisted_10, _hoisted_14, 512), [
                [_vShow, _ctx.isNormal]
              ]),
              _createElementVNode("div", {
                class: "userinfo-menu-item",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.headerLogout && _ctx.headerLogout(...args)))
              }, "로그아웃")
            ], 512), [
              [_vShow, _ctx.isOpen]
            ])
          ], 32))
    ], 544),
    _withDirectives(_createElementVNode("div", {
      class: "nav-area",
      ref: "navElement",
      onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleNav(false)))
    }, [
      _createVNode(_component_nav_bar, { ref: "navBarElement" }, null, 512)
    ], 544), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}